import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types+node@22.20.2_react_553cbaca1ae44cc8ed8c1786112d26fa/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types+node@22.20.2_react_553cbaca1ae44cc8ed8c1786112d26fa/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LessonsGridClient"] */ "/app/src/app/(frontend)/academy/[slug]/LessonsGrid.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/academy/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AcademyCardsBlockClient"] */ "/app/src/blocks/AcademyCards/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnleitungenBlockClient"] */ "/app/src/blocks/AnleitungenBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BasicCampsBlock"] */ "/app/src/blocks/BasicCamps/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlueTextImageSectionBlock"] */ "/app/src/blocks/BlueTextImageSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DownloadsBlockClient"] */ "/app/src/blocks/DownloadsBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureCardsBlock"] */ "/app/src/blocks/FeatureCards/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalsSectionBlock"] */ "/app/src/blocks/GoalsSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IframeBlock"] */ "/app/src/blocks/Iframe/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSectionBlock"] */ "/app/src/blocks/ImageSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LektionBlockClient"] */ "/app/src/blocks/LektionBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsBlockClient"] */ "/app/src/blocks/NewsBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RechnerBlock"] */ "/app/src/blocks/RechnerBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderCardBlock"] */ "/app/src/blocks/SliderCard/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabbedContentBlock"] */ "/app/src/blocks/TabbedContent/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsBlock"] */ "/app/src/blocks/TestimonialsBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextImageSectionBlock"] */ "/app/src/blocks/TextImageSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TippsBlock"] */ "/app/src/blocks/TippsBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["USPSectionBlock"] */ "/app/src/blocks/USPSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoSectionBlock"] */ "/app/src/blocks/VideoSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WeatherAvalancheSectionBlock"] */ "/app/src/blocks/WeatherAvalancheSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WissensquizBlock"] */ "/app/src/blocks/WissensquizBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YoutubeSectionBlock"] */ "/app/src/blocks/YoutubeSection/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/src/components/Card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollectionImageLink"] */ "/app/src/components/CollectionImageLink/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LocalmindAi/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/BergfuehrerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/ImageColumnSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/PartnersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/PartnersSectionNoSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/TextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Termine/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TermineAccordion/index.tsx");
